import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllQrCode,
  getSingleQrCode,
  createQrCode,
  updateQrCode,
  deleteQrCode,
  toggleQrCode,
} from "@/api/online-ordering/settings/qrCode";

// Thunks

export const fetchAllQrCode = createAsyncThunk(
  "qrCodes/fetchAll",
  async (restaurant_id, { rejectWithValue }) => {
    const res = await getAllQrCode(restaurant_id);
    if (res.status === "success") return res.data.qr_codes;
    return rejectWithValue(res.message);
  }
);

export const fetchSingleQrCode = createAsyncThunk(
  "qrCodes/fetchOne",
  async (id, { rejectWithValue }) => {
    const res = await getSingleQrCode(id);
    if (res.status === "success") return res.data.qrCode;
    return rejectWithValue(res.message);
  }
);

export const updateExistingQrCode = createAsyncThunk(
  "qrCodes/update",
  async ({ id, data }, { rejectWithValue }) => {
    const res = await updateQrCode(id, data);
    if (res.status === "success") return res.data.qrCode;
    return rejectWithValue(res.message);
  }
);

export const updateToggleQrCode = createAsyncThunk("qrCodes/toggle", async ({ id }, { rejectWithValue }) => {
    const res = await toggleQrCode(id);
    if (res.status === "success") return res.data;
    return rejectWithValue(res.message);
});

export const deleteQrCodeById = createAsyncThunk(
  "qrCodes/delete",
  async (id, { rejectWithValue }) => {
    const res = await deleteQrCode(id);
    if (res.status === "success") return id;
    return rejectWithValue(res.message);
  }
);

// Initial State

const initialState = {
  qrCodes: [],
  singleQrCode: null,

  getLoading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,

  success: null,
  error: null,
  requestStatus: false,
};

// Slice

const qrCodeSlice = createSlice({
  name: "qrCodes",
  initialState,
  reducers: {
    clearQrCodeMessages: (state) => {
      state.success = null;
      state.error = null;
      state.requestStatus = false;
    },
  },
  extraReducers: (builder) => {
    builder

      // Fetch All
      .addCase(fetchAllQrCode.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchAllQrCode.fulfilled, (state, action) => {        
        state.getLoading = false;
        state.qrCodes = action.payload;
        state.requestStatus = true;
      })
      .addCase(fetchAllQrCode.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Fetch Single
      .addCase(fetchSingleQrCode.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchSingleQrCode.fulfilled, (state, action) => {
        state.getLoading = false;
        state.singleQrCode = action.payload;
        state.requestStatus = true;
      })
      .addCase(fetchSingleQrCode.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Update
      .addCase(updateExistingQrCode.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(updateExistingQrCode.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.qrCodes = state.qrCodes.map((qrCode) =>
          qrCode.id === action.payload.id ? action.payload : qrCode
        );
        state.success = "Qr Code updated successfully!";
        state.requestStatus = true;
      })
      .addCase(updateExistingQrCode.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // toggle website/QRcode availability
      .addCase(updateToggleQrCode.pending, (state) => {
          state.updateLoading = true;
          state.error = null;
          state.requestStatus = false;
      })
      .addCase(updateToggleQrCode.fulfilled, (state, action) => {
          state.updateLoading = false;          
          state.qrCodes = state.qrCodes.map((qrCode) =>
            qrCode.id === action.payload.qr_code.id
              ? {
                  ...qrCode,
                  status: action.payload.qr_code.status,
                }
              : qrCode
          );

          state.success = "Updated successfully!";
          state.requestStatus = true;
      })
      .addCase(updateToggleQrCode.rejected, (state, action) => {
          state.updateLoading = false;
          state.error = action.payload;
          state.requestStatus = false;
      })

      // Delete
      .addCase(deleteQrCodeById.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(deleteQrCodeById.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.qrCodes = state.qrCodes.filter(
          (qrCode) => qrCode.id !== action.payload
        );
        state.success = "Qr Code deleted successfully!";
        state.requestStatus = true;
      })
      .addCase(deleteQrCodeById.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      });
  },
});

export const { clearQrCodeMessages } = qrCodeSlice.actions;
export default qrCodeSlice.reducer;
